<template>
	<div class="page-header">
		<slot name="header"></slot>
		<slot name="jumper"></slot>
	</div>
</template>

<script>
	export default {
		name: 'bsf-page-header',
		props(){
			return{
				size:String
			}
		},
		data() {
			return {
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				console.log()
			})
		},
		computed: {

		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.page-header {
		position: relative;
		padding-bottom: 10px;
		padding-top: 10px;
		margin:0 0 20px 0;
		h1,
		h2,
		h3,
		h4,
		h5 {
			position: relative;
			margin: 0;
			line-height: 30px;
		}
		small {
			margin-left: 10px;
			line-height: 30px;
			font-size: 14px;
		}
		a {
			text-decoration: none;
			color: @ces;
			font-size: 14px;
			.iconfont {
				font-size: 16px;
				.mgr(5px);
			}
		}
		&.un {
			.unbd;
			&:before {
				content: "";
				position: absolute;
				left: 0;
				bottom: 0;
				width: 30px;
				height: 1px;
				background-color: @ces;
			}
		}
		.nav {
			position: absolute;
			right: 0;
			bottom: 10px;
			li {
				a {
					.trs;
					.unbdr;
					padding: 0 30px;
					line-height: 30px;
					color: @cc;
					&:hover {
						background-color: @ces;
						color: @cwh;
					}
					&.more {
						padding: 0;
						color: @cwh;
					}
				}
			}
			>li+li {
				margin-left: 10px;
			}
		}
	}
	
	a.page-header {
		display: block;
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// pageheader.vue?7f4a2e78